import React from "react";
import { FiActivity } from "react-icons/fi";

function ActivityLog({ activities, selectedDate }) {
  const dateLabel = selectedDate
    ? selectedDate.toLocaleDateString(undefined, {
        weekday: "long",
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "Selected date";

  if (!activities || activities.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50 p-5 text-center">
        <FiActivity className="w-6 h-6 text-slate-400 mx-auto mb-2" />
        <p className="text-sm font-medium text-slate-600">No activity on {dateLabel}</p>
        <p className="text-xs text-slate-500 mt-1">Check-in and check-out events will appear here</p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-slate-50">
        <div>
          <h3 className="text-sm font-bold text-[#1a365d]">Activity log</h3>
          <p className="text-xs text-slate-500">{dateLabel}</p>
        </div>
        <span className="text-xs font-medium text-slate-500">{activities.length} entries</span>
      </div>
      <ul className="divide-y divide-slate-100">
        {activities.map((item, index) => {
          const timestamp = new Date(item.timestamp);
          const isCheckIn = item.type === "check-in";
          return (
            <li key={index} className="flex items-center justify-between gap-4 px-4 py-3 hover:bg-slate-50/80">
              <div className="flex items-center gap-3">
                <span
                  className={`w-2 h-2 rounded-full shrink-0 ${
                    isCheckIn ? "bg-emerald-500" : "bg-rose-500"
                  }`}
                />
                <div>
                  <p className="text-sm font-semibold text-slate-800 capitalize">
                    {item.type?.replace("-", " ")}
                  </p>
                  <p className="text-xs text-slate-500">
                    {timestamp.toLocaleDateString(undefined, {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>
              <span className="text-sm font-semibold text-[#1a365d] tabular-nums">
                {timestamp.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ActivityLog;
